import { GlobalContants } from "src/app/common/constants/global.contants";
import { ReportTableColumn } from "../../../../models/reports.model";
import { PropertyDetailMenuEnum } from "./residential-property-detail.enum";
import { DataType } from "src/app/common/models/enums/common.enum";

export class ReportPropertyDetailConstant {

    static overViewMenu = [
        {
            label: 'reports.overview',
            name: PropertyDetailMenuEnum.overview
        },
        {
            label: 'reports.property_information',
            name: PropertyDetailMenuEnum.propertyInformation
        },
        {
            label: 'reports.builtup_information',
            name: PropertyDetailMenuEnum.builtInformation,
        },
        // {
        //     label: 'reports.costOfConstruction',
        //     name: PropertyDetailMenuEnum.costOfconstruction,
        // },
        {
            label: 'reports.amenities',
            name: PropertyDetailMenuEnum.amentities,
        },
        {
            label: 'reports.residentialUnits',
            name: PropertyDetailMenuEnum.unit,
        },
        {
            label: 'reports.unitTransactionsPrices',
            name: PropertyDetailMenuEnum.unitTransaction,
        }, {
            label: 'reports.propertyTransactions',
            name: PropertyDetailMenuEnum.propertyTransaction,
        },
        {
            label: 'reports.residentialRentalIncome',
            name: PropertyDetailMenuEnum.rentalIncome,
        },
        {
            label: 'reports.commercialRentalIncomeAssessment',
            name: PropertyDetailMenuEnum.commercialRentalIncome,
        },
        {
            label: 'reports.nearbyRentalsAndOccupancy',
            name: PropertyDetailMenuEnum.NearByRentalAndOccupancy,
        }
    ]

    static residentialColumns: ReportTableColumn[] = [
        {
            header: 'unit_type',
            columnName: 'reports.unitType',
            field: 'unit_type',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: false,

        },
        {
            header: 'count',
            columnName: 'reports.count',
            field: 'count',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: true
        },

        {
            header: 'min_size',
            columnName: 'reports.minSize',
            field: 'min_size',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.squareMeter,

        },
        {
            header: 'max_size',
            columnName: 'reports.maxSize',
            field: 'max_size',
            border: false,
            isSortable: true,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.squareMeter,
        },
        {
            header: 'avg_size',
            columnName: 'reports.AverageSize',
            field: 'avg_size',
            border: false,
            isSortable: true,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.squareMeter,

        }
    ]

    static unitTransactionPropertyColumns: ReportTableColumn[] = [
        {
            header: 'u_unit_uid',
            columnName: 'reports.unitId',
            field: 'u_unit_uid',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },

        {
            header: 'u_unit_type',
            columnName: 'reports.unitType',
            field: 'u_unit_type',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'transaction_date',
            columnName: 'reports.transactionDate',
            field: 'transaction_date',
            border: false,
            isSortable: true,
            isContainsHTML: false,
            convertNumber: false
        },
        {
          header: 'transaction_type',
          columnName: 'reports.transactionType',
          field: 'transaction_type',
          border: false,
          isSortable: true,
          isContainsHTML: false,
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            border: true,
            isSortable: true,
            valSymbol: '',
            isContainsHTML: true,
            convertNumber: true,
            symbol: DataType.currencyCode,
            recordType: true
        },
        // {
        //     header: 'u_unit_area',
        //     columnName: 'reports.unitSize',
        //     field: 'u_unit_area',
        //     isSortable: true,
        //     border: false,
        //     isContainsHTML: false,
        //     symbol: DataType.squareMeter,
        //     convertNumber: true
        // },
        // {
        //     header: 'value_type',
        //     columnName: 'reports.valueType',
        //     field: 'value_type',
        //     border: false,
        //     isSortable: true,
        //     isContainsHTML: false,
        //     convertNumber: false
        // }
         {
          header: 'transaction_area',
          columnName: 'reports.transaction_area',
          field: 'transaction_area',
          isSortable: true,
          border: false,
          isContainsHTML: false,
          symbol: DataType.squareMeter,
          convertNumber: true,
        },
        {
            header: 'transaction_rate',
            columnName: 'reports.transaction_rate',
            field: 'transaction_rate',
            border: false,
            isSortable: true,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
        }
    ]

    static transactionPropertyColumns: ReportTableColumn[] = [
        {
            header: 'property_name',
            columnName: 'reports.PropertyName',
            field: 'property_name',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },

        // {
        //     header: 'size',
        //     columnName: 'reports.size',
        //     field: 'size',
        //     isSortable: true,
        //     border: false,
        //     isContainsHTML: false,
        //     symbol: DataType.squareMeter,
        //     convertNumber: true
        // },

        // {
        //     header: 'type',
        //     columnName: 'Type',
        //     field: 'type',
        //     isSortable: true,
        //     border: false,
        //     isContainsHTML: false,
        //     convertNumber: false
        // },
        {
            header: 'transaction_date',
            columnName: 'reports.transactionDate',
            field: 'transaction_date',
            border: false,
            isSortable: true,
            isContainsHTML: false,
            convertNumber: false
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            border: true,
            isSortable: true,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyCode,
        },
        {
            header: 'transaction_area',
            columnName: 'reports.transaction_area',
            field: 'transaction_area',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            symbol: DataType.squareMeter,
            convertNumber: true,
        },
        {
            header: 'value_type',
            columnName: 'reports.valueType',
            field: 'value_type',
            border: false,
            isSortable: true,
            isContainsHTML: false,
            convertNumber: false
        }
    ]

    static retailTransactionPropertyColumns: ReportTableColumn[] = [
        {
            header: 'transaction_date',
            columnName: 'reports.transactionDate',
            field: 'transaction_date',
            border: false,
            isSortable: true,
            isContainsHTML: false,
            convertNumber: false
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            border: true,
            isSortable: true,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyCode,
        },
        {
            header: 'transaction_area',
            columnName: 'reports.transaction_area',
            field: 'transaction_area',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            symbol: DataType.squareMeter,
            convertNumber: true,
        },
        {
            header: 'transaction_rate',
            columnName: 'reports.property_transaction_rate',
            field: 'transaction_rate',
            border: false,
            isSortable: true,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
        },
        {
          header: 'transaction_type',
          columnName: 'reports.transactionType',
          field: 'transaction_type',
          border: false,
          isSortable: true,
          isContainsHTML: false,
        },
        {
            header: 'record_type',
            columnName: 'reports.record_type',
            field: 'record_type',
            border: false,
            isSortable: true,
            isContainsHTML: true,
        },
    ]

    static rentalIncomeCount: ReportTableColumn[] = [
        {
            header: 'unit_type',
            columnName: 'reports.type',
            field: 'unit_type',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'rental_price',
            columnName: 'reports.monthlyRental',
            field: 'rental_price',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            symbol: DataType.currencyCode,
        },
        {
            header: 'rental_rate',
            columnName: 'reports.lease_rate',
            field: 'rental_rate',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            symbol: DataType.currencyWithSquareMeter,
        },
    ]

    static rentalIncomeArea: ReportTableColumn[] = [
        {
            header: 'unit_type',
            columnName: 'reports.type',
            field: 'unit_type',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },
       

        {
            header: 'rental_price',
            columnName: 'reports.monthlyRental',
            field: 'rental_price',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            symbol: DataType.currencyCode,
        },
         {
            header: 'ir_lease_rate',
            columnName: 'reports.lease_rate',
            field: 'lease_rate',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            symbol: DataType.currencyWithSquareMeter,
            convertNumber: false
        },
    ]

    static nearByRentalAndOccupancy: ReportTableColumn[] =[
      {
        header : 'property_grade',
        columnName : 'reports.property_grade',
        field: 'property_grade',
        isSortable: false,
        border: false,
        isContainsHTML: false,
        convertNumber: false
      },
      {
        header: 'rental_rates',
        columnName: 'reports.rental_rate',
        field: 'rental_rates',
        isSortable: false,
        border: false,
        isContainsHTML: false,
        convertNumber: false,
        symbol: DataType.currencyWithSquareMeter,
        isBreak: true

      },
       {
        header: 'occupancy_percent',
        columnName: 'reports.occupancy_percent',
        field: 'occupancy',
        isSortable: false,
        border: false,
        isContainsHTML: false,
        convertNumber: false,
       },
    ]

    static nearByRentalAndOccupancySaudi: ReportTableColumn[] =[
      {
        header : 'property_grade',
        columnName : 'reports.property_grade',
        field: 'property_grade',
        isSortable: false,
        border: false,
        isContainsHTML: false,
        convertNumber: false
      },
      {
        header: 'rental_rates',
        columnName: 'reports.rental_rate',
        field: 'rental_rates',
        isSortable: false,
        border: false,
        isContainsHTML: false,
        convertNumber: false,
        symbol: DataType.currencyWithSquareMeter,
        isBreak: true
      }
    ]


}
